import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class MainCollectionBanner {
  constructor(section) {
    this.el = section.el;

    // The cards are a fixed width rather than a fraction of the track, so the
    // row is left-aligned on desktop and drag-scrolls on mobile. autoWidth is
    // what lets Splide read that width off the slide instead of imposing one.
    initCarousel(
      this.el,
      {
        autoWidth: true,
        padding: {
          right: 16,
        },
        arrows: false,
        pagination: false,
        gap: '0.5rem',
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.md]: {
            padding: '0',
          },
        },
      },
      true,
    );
  }
}
